import { BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { refreshExpiredFunc } from '../store/slices/refreshExpiredReducer';
import { globalVal } from '../utils/global-values';
import { errorMsgs } from '../utils/error-msgs';
import { enqueueSnackbar } from 'notistack';
import { decrypt } from '../utils/decrypt';

export const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_ADDRESS || 'https://corporatetestapi.ahlpay.com.tr/api/',
  prepareHeaders: (headers) => {
    let token = localStorage.getItem('accessToken');
    if (!token) {
      token = localStorage.getItem('verifyToken');
    } else {
      localStorage.removeItem('verifyToken');
    }
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

export const baseQueryWithReauth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
  const isLoginPage = window.location.href.includes('/login') || window.location.pathname === '/login';

  if (globalVal.isLoggedOut && !isLoginPage) {
    // Eğer kullanıcı çıkış yapmışsa ve login sayfasında değilse, tüm istekleri durduruyoruz.
    return { error: { status: 401, data: { message: 'Oturum kapalı, tekrar giriş yapın.' } } };
  }

  try {
    let result: any = await baseQuery(args, api, extraOptions);
    api.dispatch(refreshExpiredFunc())
    if (result.data && result.data.data?.token) {
      let getSession = localStorage.getItem('accessToken');

      if (getSession)
        localStorage.setItem('accessToken', result.data.data.token);
      else
        localStorage.setItem('verifyToken', result.data.data.token);
    }
    if (result.error) {
      let handled = false;

      // Sadece bir kez hata mesajı gösterilmesi için, önce açık kart numarası kontrolü, sonra şifreli için decrypt
      // Eğer data dizisinde açık hesap/kart numarası varsa, doğrudan göster; eğer decrypt başarılı dönerse onu kullan
      const cardNumbers = (Array.isArray(result.error?.data?.data)) ? result.error.data.data : null;
      if (
        cardNumbers &&
        cardNumbers.length > 0 &&
        result.error?.data?.message
      ) {
        // Her bir kartı decrypt etmeyi dene, başarılıysa decrypt edilmiş halini, değilse orijinalini kullan
        const displayCards = cardNumbers.map((item: string) => {
          try {
            const decrypted = decrypt(item);
            // Decrypt başarılı ve farklı ise onu kullan
            return decrypted !== "" ? decrypted : item;
          } catch {
            return item;
          }
        });
        const combinedMessage = `${displayCards.join(', ')} - ${result.error.data.message}`;
        enqueueSnackbar(combinedMessage, { variant: 'error' });
        result.error.data.message = combinedMessage;
        handled = true;
      } else if (
        cardNumbers &&
        cardNumbers.length > 0 &&
        result.error?.data?.message
      ) {
        // Kart numaraları şifreli ise decrypt et
        const decryptedCards = cardNumbers.map((item: string) => {
          try {
            return decrypt(item);
          } catch {
            return item;
          }
        });
        const combinedMessage = `${decryptedCards.join(', ')} - ${result.error.data.message}`;
        enqueueSnackbar(combinedMessage, { variant: 'error' });
        result.error.data.message = combinedMessage;
        handled = true;
      }

      if (!handled && result.error?.data?.message && result.error?.status !== 401) {
        if (result.error?.status === 404) {
          // 404 kayıt yok demek bunun için hata mesaji dönme epin için yapıldı bu condition.
          return;
        }
        if (Array.isArray(result.error?.data?.message)) {
          enqueueSnackbar(result.error.data.message.join('\n'), { variant: 'error' });
        } else if (result.error?.data?.message) {
          enqueueSnackbar(result.error.data.message, { variant: 'error' });
        }
      } else if (!handled) {

        if (!globalVal.isLoggedOut && !window.location.href.includes('/authentication/forget-pass')) {
          enqueueSnackbar(errorMsgs(result.error?.status, api), { variant: 'error' });
        }
        if (result.error?.status === 401) {
          globalVal.isLoggedOut = true; // Çıkış yapılmış durumu işaretle
        }
        // 500 hatası alındığında bir önceki sayfaya dönme
        /* if (result.error?.status === 500) {
          window.history.back();
        } */
      }
    }
    return result;
  } catch (error: any) {
    if (error?.name === 'AbortError') {
      enqueueSnackbar('İstek zaman aşımına uğradı', { variant: 'error' });
    } else {
      enqueueSnackbar('Beklenmeyen bir hata oluştu', { variant: 'error' });
    }
  } finally {
  }
};

